import { useTranslation } from 'react-i18next';

import BottomModal from './common/BottomModal';
import Input from './common/Input';

const PrivacyPreferences = ({
  preferences,
  setPreferences,
  onClose,
  onClickOutside
}) => {
  const { t } = useTranslation();

  const handleChange = (field, value) => {
    setPreferences((prevPrefs) => ({
      ...prevPrefs,
      [field]: value,
    }));
  };

  return (
    <BottomModal className='privacy-preferences' onClickOutside={onClickOutside}>
      <div className='privacy-preferences'>
        <h2>{t('privacy.preferences.title')}</h2>

        <div className='privacy-preferences__content'>
          <Input
            type='checkbox'
            name='marketingConsent'
            label={t('privacy.preferences.marketing')}
            value={preferences.marketingConsent}
            onChange={handleChange}
          />
          <Input
            type='checkbox'
            name='profilingConsent'
            label={t('privacy.preferences.profiling')}
            value={preferences.profilingConsent}
            onChange={handleChange}
          />
          <Input
            type='checkbox'
            name='statisticsConsent'
            label={t('privacy.preferences.statistics')}
            value={preferences.statisticsConsent}
            onChange={handleChange}
          />
        </div>

        <button
          className='button button--privacy-preferences'
          onClick={onClose}
        >
          {t('privacy.preferences.confirm')}
        </button>
      </div>
    </BottomModal>
  );
};

export default PrivacyPreferences;
